import React from 'react';

import { Alert, AlertTitle, Grid, Link } from '@mui/material';

const Pending = ({ signature }) => {
  return (
    <Grid item xs={12}>
      <Alert severity='info'>
        <AlertTitle>En attente de signature</AlertTitle>
        <Link href={signature.signUrl} color='inherit' sx={{ padding: '0' }}>
          Aller signer ce mandat
        </Link>
      </Alert>
    </Grid>
  );
};

export default React.memo(Pending);
